export default {
  // Typography
  fonts: {
    title: "Space Grotesk, sans-serif",
    main: "Space Grotesk, sans-serif",
    code: "Source Code Pro, monospace"
  },

  // Font weights
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700
  },

  // Font sizes
  fontSizes: {
    xs: "12px",
    sm: "14px",
    md: "16px",
    lg: "18px",
    xl: "20px",
    "2xl": "24px",
    "3xl": "30px",
    "4xl": "36px",
    "5xl": "48px",
    "6xl": "64px"
  },

  // Colors
  colors: {
    // Brand colors
    primary: "#854CE6",
    secondary: "#6D44B8",
    accent: "#FF5757",

    // Background colors
    background1: "#222A35",
    background2: "#19212C",
    card: "#1B2330",

    // Text colors
    text: "#C8CFD8",
    text1: "#F2F5F7",
    text2: "#626970",
    textLight: "#FFFFFF",
    textDark: "#141414",

    // Status colors
    success: "#4CAF50",
    warning: "#FFA726",
    error: "#EF5350",
    info: "#29B6F6",

    // Button colors
    button: "#854CE6",
    buttonHover: "#7039DD",
    buttonActive: "#6D44B8"
  },

  // Breakpoints
  breakpoints: {
    xs: "320px",
    sm: "576px",
    md: "768px",
    lg: "1024px",
    xl: "1200px"
  },

  // Spacing
  spacing: {
    xs: "4px",
    sm: "8px",
    md: "16px",
    lg: "24px",
    xl: "32px",
    "2xl": "48px",
    "3xl": "64px"
  },

  // Border radius
  borderRadius: {
    sm: "4px",
    md: "8px",
    lg: "16px",
    full: "9999px"
  },

  // Shadows
  shadows: {
    sm: "0 2px 8px rgba(0, 0, 0, 0.15)",
    md: "0 4px 16px rgba(0, 0, 0, 0.15)",
    lg: "0 8px 32px rgba(0, 0, 0, 0.15)"
  },

  // Transitions
  transitions: {
    fast: "0.2s ease-in-out",
    default: "0.3s ease-in-out",
    slow: "0.5s ease-in-out"
  },

  // Z-index
  zIndex: {
    base: 0,
    tooltip: 10,
    modal: 20,
    popover: 30,
    header: 40,
    overlay: 50
  },

  // Grid
  grid: {
    container: "1200px",
    gutter: "24px"
  }
};
